<template>
  <v-row class="fill-height">
    <!-- Server Info -->
    <v-col cols="12" sm="6">
      <gg-card height="100%">
        <gg-card-text class="pa-3">
          <div class="body-1 mb-3 text-left">
            <v-icon size="24" color="primary" class="pb-1">mdi-account-card-details</v-icon>
            <span class="ml-2">Server Information</span>
          </div>
          <div v-if="!loading">
            <p class="ma-0">
              <b class="pr-1">Server Status:</b>
              <v-icon small class="mb-1" :color="statusColor(this.serverStatus)">
                mdi-circle
              </v-icon>
              <span class="ma-0 text-capitalize" v-html="serverStatus" />
            </p>
            <p class="ma-0">
              <b class="pr-1">Server Hostname:</b>
              {{ hosting_detail.url }}
            </p>
          </div>
        </gg-card-text>
      </gg-card>
    </v-col>
    <!-- Disk Space Usage -->
    <v-col cols="12" sm="6">
      <gg-card>
        <gg-card-text class="text-center pa-3">
          <div class="body-1 mb-3 text-left">
            <v-icon size="24" color="primary" class="pb-1">mdi-harddisk</v-icon>
            <span class="ml-2">Disk Space Usage</span>
          </div>
          <div v-if="!loading">
            <v-progress-circular :size="70"
                                 :rotate="-90"
                                 :width="10"
                                 :value="spaceUsedPercent"
                                 color="primary">
              {{ spaceUsedPercent }}%
            </v-progress-circular>
            <p class="mt-1 mb-0" v-html="spaceUsed" />
          </div>
        </gg-card-text>
      </gg-card>
    </v-col>

    <v-col cols="12" sm="6">
      <gg-card>
        <gg-card-text class="text-center pa-3">
          <div class="body-1 mb-3 text-left">
            <v-icon size="24" color="primary" class="pb-1">mdi-memory</v-icon>
            <span class="ml-2">Memory Usage</span>
          </div>
          <div v-if="!loading">
            <v-progress-circular :size="70"
                                 :rotate="-90"
                                 :width="10"
                                 :value="memUsagePercent"
                                 color="primary">
              {{ memUsagePercent }}%
            </v-progress-circular>
            <p class="mt-1 mb-0" v-html="memUsage" />
          </div>
        </gg-card-text>
      </gg-card>
    </v-col>
    <v-col cols="12" sm="6">
      <gg-card>
        <gg-card-text class="text-center pa-3">
          <div class="body-1 mb-3 text-left">
            <v-icon size="24" color="primary" class="pb-1">mdi-upload</v-icon>
            <span class="ml-2">Bandwidth Usage</span>
          </div>
          <div v-if="!loading">
            <v-progress-circular :size="70"
                                 :rotate="-90"
                                 :width="10"
                                 :value="bandwidthPercent"
                                 color="primary">
              {{ bandwidthPercent }}%
            </v-progress-circular>
            <p class="mt-1 mb-0" v-html="bandwidthUsage" />
          </div>
        </gg-card-text>
      </gg-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import { humanFileSize, percent, statusColor } from '@/helpers/helpers'

export default {
  name: 'ServiceStatus',
  props: {
    loading: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  computed: {
    ...mapGetters(['hosting', 'hosting_detail']),
    serverStatus () {
      return this.hosting_detail.state
    },
    spaceUsedPercent () {
      return this.percent(this.hosting_detail.disk_used, this.hosting_detail.disk_total)
    },
    memUsagePercent () {
      return this.percent(this.hosting_detail.mem_used, this.hosting_detail.mem_total)
    },
    bandwidthPercent () {
      return this.percent(this.hosting_detail.bw_used, this.hosting_detail.bw_total)
    },
    spaceUsed () {
      const value = `${this.humanFileSize(this.hosting_detail.disk_used, false)} / ${this.humanFileSize(this.hosting_detail.disk_total, false)}`
      const percent = `(${this.percent(this.hosting_detail.disk_used, this.hosting_detail.disk_total)} %)`

      if (this.hosting_detail.disk_total !== 'unlimited') {
        return `${value} ${percent}`
      } else {
        return value
      }
    },
    memUsage () {
      const value = `${this.humanFileSize(this.hosting_detail.mem_used)} / ${this.humanFileSize(this.hosting_detail.mem_total)}`
      const percent = `(${this.percent(this.hosting_detail.mem_used, this.hosting_detail.mem_total)} %)`

      if (this.hosting_detail.mem_total !== 'unlimited') {
        return `${value} ${percent}`
      } else {
        return value
      }
    },
    bandwidthUsage () {
      const value = `${this.humanFileSize(this.hosting_detail.bw_used)} / ${this.humanFileSize(this.hosting_detail.bw_total)}`
      const percent = `(${this.percent(this.hosting_detail.bw_used, this.hosting_detail.bw_total)} %)`

      if (this.hosting_detail.bw_total !== 'unlimited') {
        return `${value} ${percent}`
      } else {
        return value
      }
    }
  },
  methods: {
    humanFileSize,
    percent,
    statusColor,
  },
}
</script>
